var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.body)?_c('div',{staticClass:"heading-notation"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.$md.render(_vm.body))}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }